import { Modal } from 'antd';
import { XMarkSolid } from '../../utils/icons';
import { useState } from 'react';
import LoginForm from './LoginForm';
import useStyle from './index.styles';
import { ReactComponent as Logo } from '../../assets/images/logo.svg';
import RecoveryPasswordForm from './RecoveryPasswordForm';

const Login = ({ onClose }: { onClose: () => void }) => {
  const [view, setView] = useState<'loginForm' | 'recoveryPassword'>('loginForm');
  const [email, setEmail] = useState<string>('');
  const classes = useStyle();

  return (
    <>
      <Modal
        footer={<div className="h-full w-full md:hidden" onClick={onClose}></div>}
        destroyOnClose
        title={
          <div
            className="flex h-full w-full items-center justify-center md:hidden"
            onClick={onClose}
          >
            <Logo className="my-[24px]" />
          </div>
        }
        open
        onCancel={onClose}
        className={classes.loginModal}
        closeIcon={<XMarkSolid />}
      >
        {view === 'loginForm' && (
          <LoginForm onClose={onClose} setEmail={setEmail} setView={setView} />
        )}
        {view === 'recoveryPassword' && (
          <RecoveryPasswordForm email={email} goToLogin={() => setView('loginForm')} />
        )}
      </Modal>
    </>
  );
};

export default Login;
